import dayjs from "dayjs";
import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { LearningResourceType, Media, MediaType } from "src/interfaces/Media";

interface UseMediaListArgs {
  corporateId: string;
  mediaType?: MediaType;
  learningResourceType?: LearningResourceType;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const useMediaList = ({
  corporateId,
  mediaType,
  learningResourceType,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseMediaListArgs): PaginatedListResult<Media> => {
  const buildUrl = () => {
    if (!corporateId) return null;
    const base = `${ServicesURL.library}?corporateId=${corporateId}&generateUrl=true`;
    if (learningResourceType) {
      return `${base}&learning_resource_type=${learningResourceType}`;
    }
    if (mediaType) {
      return `${base}&type=${mediaType}`;
    }
    return null;
  };

  const normalizedFilters = fieldFilters
    ? {
        ...fieldFilters,
        ...(fieldFilters.date
          ? { date: dayjs(fieldFilters.date).valueOf() }
          : {}),
      }
    : undefined;

  return usePaginatedList<Media>(buildUrl(), {
    page,
    pageSize,
    search,
    fieldFilters: normalizedFilters,
  });
};
